import { Settings, Headphones } from 'lucide-react'
import { useDashboardStore } from '../../store/dashboardStore'
import { useHaptic } from '../../hooks/useHaptic'

export default function Header() {
  const setActiveModal = useDashboardStore(s => s.setActiveModal)
  const haptic = useHaptic()

  const openSettings = () => {
    haptic.light()
    setActiveModal('settings')
  }

  const openSupport = () => {
    haptic.light()
    setActiveModal('support')
  }

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: 'rgba(10,10,10,0.85)',
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      {/* Support button — наушники, открывает чат поддержки. Зеркалит
          ширину кнопки настроек, чтобы бренд оставался по центру. */}
      <button
        onClick={openSupport}
        aria-label="Support"
        style={{
          width: 40, height: 40,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
          flexShrink: 0,
          transition: 'background 0.2s',
        }}
      >
        <Headphones size={17} color="#8E8E93" />
      </button>

      {/* Centered SCALPEX brand */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* Chart icon logomark */}
        <div style={{
          width: 28, height: 28, borderRadius: 8, flexShrink: 0,
          background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 0 12px rgba(16, 185, 129, 0.35)',
        }}>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M2 10.5L5.5 7L8 9.5L13 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="13" cy="4" r="1.5" fill="#fff"/>
          </svg>
        </div>

        <span
          className="font-display"
          style={{
            fontSize: 17,
            fontWeight: 700,
            letterSpacing: '0.06em',
            background: 'linear-gradient(135deg, #34D399 0%, #10B981 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          SCALPEX
        </span>
      </div>

      {/* Settings button — фирменный зелёный, не серый */}
      <button
        onClick={openSettings}
        data-hint="settings-btn"
        style={{
          width: 40, height: 40,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
          flexShrink: 0,
          transition: 'background 0.2s',
        }}
        aria-label="Settings"
      >
        <Settings size={17} color="#34D399" />
      </button>
    </header>
  )
}
